import React from 'react'
import '../../styles/learn.css'

const Learn = () => {
  return (
    <div className='learn-container'>
      <div className='learn-card'>
        <h1 className='learn-title'>Learn</h1>
        <p>
          Janette King is a Caribbean-Canadian alternative RnB artist whose
          debut LP What We Lost landed her acclaim in, among others, Complex &
          Hypebeast as well as performance opportunities which include Montreal
          Jazz Fest, Ottawa Blues Fest, Noise Pop and support slots for
          Cupcakke, Sudan Archives, & Jamila Woods. Most recently, King wrote
          and performed on two tracks off Gayance’s album Mascarade which came
          out in March 2023 and landed on the esteemed Polaris Music Prize
          shortlist. King also released 2-track dance EP How Sad in June 2023 in
          celebration of Pride Month. Janette’s much-anticipated sophomore album
          that was released in October 2024 on Birthday Cake Records (Leith
          Ross, Begonia). <br /> <br />
          <i>
            "Janette King has made a very special debut album that ought to
            place King right near the top of the list of this country's up and
            coming R&B artists. What We Lost is fully realized and has a
            confidence that is well beyond King's years. The album's title track
            finds King flirting with techno, and it's something that would fit
            comfortably on a playlist beside Ela Minus, while "You Don't Love
            Me" wouldn't seem out of place sandwiched between any Alicia Keys
            tracks. To do all of this while sounding completely herself is a
            reflection of King's strength as a songwriter." - exclaim
          </i>
        </p>
      </div>
    </div>
  )
}

export default Learn
